var sliders = {
	selectors: {
		carousel: '.general-carousel',
		carouselGlobal: '.carousel-items',
		carouselReviews: '.reviews-carousel',
		carouselNews: '.news-carousel',
		carouselPackages: '.packages-carousel',
		carouselRoomItemGallery: '.room-item__gallery',
	},
	settings: { // default values for all types of carousels (can be overwritten in admin)
		one_item_slider: {
			items: {
				sm: 1,
				md: 1,
				lg: 1,
				xl: 1
			},
			gutter: 0,
			loop: false
		},
		news: {
			items: {
				sm: 2,
				md: 2,
				lg: 3,
				xl: 3
			},
			gutter: 20,
			loop: false
		},
		package: {
			items: {
				sm: 2,
				md: 2,
				lg: 2,
				xl: 2
			},
			gutter: 20,
			loop: false
		},
		package_3: {
			items: {
				sm: 2,
				md: 2,
				lg: 3,
				xl: 4
			},
			gutter: 20,
			loop: false
		},
		services_extra: {
			items: {
				sm: 1,
				md: 2,
				lg: 2,
				xl: 2
			},
			gutter: 20,
			loop: false
		},
		activity: {
			items: {
				sm: 1,
				md: 2,
				lg: 2,
				xl: 3
			},
			gutter: 20,
			loop: false
		},
		gallery_strip: {
			items: {
				sm: 2,
				md: 2,
				lg: 3,
				xl: 3
			},
			gutter: 0,
			loop: false
		},
		gallery: {
			items: {
				sm: 2,
				md: 3,
				lg: 4,
				xl: 4
			},
			gutter: 15,
			loop: false
		},
		reviews_luxury: {
			items: {
				sm: 1,
				md: 2,
				lg: 3,
				xl: 3
			},
			gutter: 20,
			loop: false
		},
		small_rooms_2: {
			items: {
				sm: 1,
				md: 2,
				lg: 3,
				xl: 4
			},
			gutter: 20,
			loop: false
		},
		small_rooms_5: {
			items: {
				sm: 1,
				md: 2,
				lg: 3,
				xl: 3
			},
			gutter: 20,
			loop: false
		},
		small_rooms_6: {
			items: {
				sm: 1,
				md: 2,
				lg: 4,
				xl: 6
			},
			gutter: 20,
			loop: false
		}
	},
	arrow:
		'<svg xmlns="http://www.w3.org/2000/svg" width="24.624" height="15.051" viewBox="0 0 24.624 15.051"> <g id="Group_329" data-name="Group 329" transform="translate(-437.761 -2253.606)"> <path id="Path_1030" data-name="Path 1030" d="M9242.152,2284.313l6.818,6.818-6.818,6.818" transform="translate(-8788 -30)" fill="none" stroke="#67a1df" stroke-width="2"/> <path id="Path_1031" data-name="Path 1031" d="M9188.761,2261.132h22.88" transform="translate(-8751)" fill="none" stroke="#67a1df" stroke-width="2"/> </g> </svg>',
	arrowLeft:
		'<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#67a1df" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>',
	arrowRight:
		'<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" class="svg-inline--fa fa-chevron-right fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#67a1df" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>',
	init: function () {
		var self = this;


		if ( document.querySelector( self.selectors.carousel ) ) {
			jQuery( self.selectors.carousel ).each( function() {
				var thisCarousel = this;
				var $this =jQuery( this );
				var type = jQuery( this ).attr('data-type');
				var items = jQuery( this ).attr('data-carousel-items') ? jQuery( this ).attr('data-carousel-items') : jQuery( this ).attr('data-items');
				var loop = jQuery( this ).attr('data-loop');
			    var showArrows = !!(jQuery( this ).attr('data-arrows') );
				var showDots = !!(jQuery( this ).attr('data-dots') );
				var autoplay = !!(jQuery( this ).attr('data-autoplay') );
				var autoplayTimeout = ( jQuery( this ).attr( 'data-timeout' ) ) ? parseInt( jQuery( this ).attr( 'data-timeout' ) ) : 5000;
				var thumbnails = !!(jQuery( this ).attr('data-thumbnails') );
				var thumbnailsContainer = $this.next('#carouselThumbnails').get(0);
				var arrowsIconLeft = jQuery( this ).attr('data-arrows-icon-left');
				var arrowsIconRight = jQuery( this ).attr('data-arrows-icon-right');
				var arrowsIcons = arrowsIconLeft && arrowsIconRight ? [arrowsIconLeft, arrowsIconRight] : [self.arrowLeft, self.arrowRight];

				var carousel = tns({
					container: thisCarousel,
					items: items ? items : self.settings[type].items.xl,
					slideBy: 1,
					gutter: self.settings[type].gutter ?? 0,
					speed: 400,
					swipeAngle: false,
					mouseDrag: true,
					loop: loop ? loop : self.settings[type].loop,
					controlsText: arrowsIcons,
					nav: thumbnails ? true : showDots,
					navPosition: "bottom",
					controls: showArrows,
					autoplay: autoplay,
					autoplayTimeout: autoplayTimeout,
					autoplayHoverPause: true,
					autoplayButtonOutput: false,
					lazyload: true,
					navContainer: thumbnailsContainer,
					navAsThumbnails: thumbnails,
					responsive: {
						0: {
							items: 1,
							gutter: 0
						},
						576: {
							items: self.settings[type].items.sm,
							gutter: self.settings[type].gutter ?? 0,
						},
						768: {
							items: self.settings[type].items.md,
							gutter: self.settings[type].gutter ?? 0,
						},
						992: {
							items: self.settings[type].items.lg,
							gutter: self.settings[type].gutter ?? 0,
						},
						1200: {
							items: items ? items : self.settings[type].items.xl,
							gutter: self.settings[type].gutter ?? 0,
						}
					}
				});

				jQuery(this).on("mouseup", function()  {
					carousel.pause(); // autoplay stop on hover fix
				});

			});
		}

		if ( document.querySelector( self.selectors.carouselReviews ) ) {
			jQuery( self.selectors.carouselReviews ).each( function() {
				var autoplay = ( jQuery( this ).attr( 'autoplay' ) ) ? true : false;
				var items = parseInt( jQuery( this ).attr( 'items' ) );

				var carousel = tns({
					container: this,
					items: 1,
					slideBy: 1,
					gutter: 30,
					mouseDrag: true,
					loop: true,
					// controlsText: [self.arrow, self.arrow],
					controls: false,
					nav: false,
					autoplay: autoplay,
					autoplayTimeout: 5000,
					autoplayButtonOutput: false,
					responsive: {
						0: {
							items: 1,
						},
						640: {
							items: 2,
						},
						1024: {
							items: items,
						}
					}
				});
			});
		}

		/*if ( document.querySelector( self.selectors.carouselNews ) ) {
			jQuery( self.selectors.carouselNews ).each( function() {
				var autoplay = ( jQuery( this ).attr( 'autoplay' ) ) ? true : false;
				var items = parseInt( jQuery( this ).attr( 'items' ) );

				var carousel = tns({
					container: this,
					items: 3,
					slideBy: 1,
					gutter: 30,

					speed: 800,
					mouseDrag: true,
					loop: false,
					// controlsText: [self.arrow, self.arrow],
					controls: false,
					nav: false,
					autoplay: autoplay,
					autoplayTimeout: 2000,
					responsive: {
						0: {
							items: 1,
						},
						640: {
							items: 2,
						},
						1024: {
							items: items,
						}
					}
				});
			});
		}*/

		if ( document.querySelector( self.selectors.carouselPackages ) ) {
			jQuery( self.selectors.carouselPackages ).each( function() {
				var autoplay = ( jQuery( this ).attr( 'autoplay' ) ) ? true : false;
				var items = parseInt( jQuery( this ).attr( 'items' ) );

				var carousel = tns({
					container: this,
					items: items,
					slideBy: 1,
					gutter: 20,

					speed: 800,
					mouseDrag: true,
					loop: false,
					// controlsText: [self.arrow, self.arrow],
					controls: false,
					nav: false,
					autoplay: autoplay,
					autoplayTimeout: 2000,
					responsive: {
						0: {
							items: 1,
						},
						640: {
							items: 2,
						},
						1024: {
							items: items,
						}
					}
				});
			});
		}

		if ( document.querySelector( self.selectors.carouselRoomGallery ) ) {
			jQuery( self.selectors.carouselRoomGallery ).each( function() {
				var carousel = tns({
					container: this,
					items: 1,
					slideBy: 1,
					speed: 400,
					mouseDrag: true,
					loop: true,
					// controlsText: [self.arrow, self.arrow],
					controls: false,
					nav: false,
				});
			});
		}

		if ( document.querySelector( self.selectors.carouselRoomItemGallery ) ) {
			jQuery( self.selectors.carouselRoomItemGallery ).each( function() {
				var autoplay = ( jQuery( this ).attr( 'autoplay' ) ) ? true : false;

				var carousel = tns({
					container: this,
					items: 1,
					slideBy: 1,
					speed: 1000,
					mouseDrag: true,
					loop: false,
					controlsText: [self.arrowLeft, self.arrowRight],
					controls: true,
					nav: false,
					autoplay: autoplay,
					autoplayTimeout: 2000,
					autoplayButtonOutput: false,
					lazyload: true,
				});
			});
		}
	},
};

export { sliders };
